import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetDrfDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_DRF_DETAILS, token);
  return res;
};

export const AddDrf = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_DRF, payload, token);
  return res;
};

export const UpdateDrf = async (payload, id) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPDATE_DRF + id, payload, token);
  return res;
};

export const DeleteDrf = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_DRF + id, id, token);
  return res;
};
